const RADIX = 36;
const RANDOM_PREFIX_LENGTH = 2;

export const createId = (): string =>
	typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
		? crypto.randomUUID()
		: `${Date.now().toString(RADIX)}-${Math.random().toString(RADIX).slice(RANDOM_PREFIX_LENGTH)}`;
